import React, { useRef, useEffect, useState } from "react";
import gif from "../../../Assets/HomePage_Assets/hoverImg.gif";
import "./HeroImgHover.css";
import { Link } from "react-scroll";

const HoverImage = () => {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleMove = (e) => {
      const rect = container.getBoundingClientRect();
      setPos({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      });
      setVisible(true);
    };

    const handleLeave = () => setVisible(false);

    container.addEventListener("mousemove", handleMove);
    container.addEventListener("mouseleave", handleLeave);

    return () => {
      container.removeEventListener("mousemove", handleMove);
      container.removeEventListener("mouseleave", handleLeave);
    };
  }, []);

  return (
    <Link to="about" smooth duration={700}>
      <div className="softimagecontainer">
        <div className="softimage" ref={containerRef}>
          <img
            src={gif}
            alt="Interactive Preview"
            className={`hover-gif ${visible ? "show" : ""}`}
            style={{
              transform: `translate(${pos.x - 200}px, ${pos.y - 200}px)`,
            }}
          />
        </div>
      </div>
    </Link>
  );
};

export default HoverImage;
